import './menu.scss';

import React, { FunctionComponent } from 'react';

import { MenuItem } from './MenuItem';
import config from '../../config';
import { useTranslation } from 'react-i18next';

type MenuBarProps = {
  showGivingCheckoutOption?: boolean;
};

export const MenuBar: FunctionComponent<MenuBarProps> = ({
  showGivingCheckoutOption = true,
}) => {
  const { t } = useTranslation();

  return (
    <nav className="menu-wrapper" aria-label={t('menu.heading')}>
      <ul className="menu">
        <MenuItem label={t('menu.home')} link={`${config.base_url}/home`} />
        <MenuItem
          label={t('menu.reports')}
          link={`${config.base_url}/reports`}
        />
        {showGivingCheckoutOption && (
          <MenuItem
            label={t('menu.givingCheckout')}
            link={`${config.base_url}/giving-checkout`}
            isSelected
          />
        )}
        <MenuItem label={t('menu.events')} link={`${config.base_url}/events`} />
        <MenuItem
          label={t('menu.campaigns')}
          link={`${config.base_url}/campaign`}
        />
        <MenuItem
          label={t('menu.branding')}
          link={`${config.base_url}/branding`}
        />
        <MenuItem
          label={t('menu.settings')}
          link={`${config.base_url}/settings`}
        />
      </ul>
    </nav>
  );
};
